import { ImporteurDTO } from 'src/app/DTOs/ImporteurDTO';import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterDataService } from 'src/app/Services/master-data.service';
import { FormGroup, FormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CountryDTO } from 'src/app/DTOs/CountryDTO';
import { ContactPersonDTO } from 'src/app/DTOs/ContactPersonDTO';

import { NotificationService } from 'src/app/Shared/prime-ng/notification.service';
import { DataResult, DataStateChangeEvent, GridDataResult, PageChangeEvent, State, pageSkip, pageTake, process } from 'src/app/Shared/prime-ng/grid-data';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';

@Component({
  selector: 'app-importeur-detail',
  standalone: true,
  imports: [PrimeNgModule, FormsModule, CommonModule, RouterModule],
  templateUrl: './importeur-detail.component.html',
  styleUrl: './importeur-detail.component.css'
})

export class ImporteurDetailComponent implements OnInit {
  importeur: ImporteurDTO | null = {
    importeurId: 0,
    title: '',
    country: {
      countryId: 0,
      title: '',
      iso2: null,
      iso3: null
    },
    city: '',
    zip: '',
    street: '',
    contactPersons: [],
    canBeDeleted: true,
  };
  availableCountrys: CountryDTO[] = [{ countryId: 0, iso2: null, iso3: null, title: '' }]
  public contactPersons: ContactPersonDTO[] = [];
  public currentContactPersons: ContactPersonDTO[] = [];
  public originalContactPerson: ContactPersonDTO[] = [];
  public gridView: GridDataResult = { data: [], total: 0 };
  public gridState: State = { skip: 0, take: 5 };
  selectedCountryId: number = 0
  editMode: boolean = false
  cancelDialog: boolean = false

  constructor(private route: ActivatedRoute, private masterData: MasterDataService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.loadImporteurDetail()
    this.getAllCountrys()
    this.updateGridView()
  }

  saveImporteur() {
    if (!this.importeur) {
      this.notification('No Importeur was loaded!', 'error');
      return;
    }
    const selectedCountry = this.availableCountrys.find(c => c.countryId === this.selectedCountryId);
    if (!selectedCountry) {
      this.notification('Please select a Country!', 'error');
      return;
    }
    this.importeur.country = selectedCountry;
    this.importeur.contactPersons = this.contactPersons;

    if (this.importeur.importeurId && this.importeur.importeurId > 0) {
      this.masterData.updateImporteur(this.importeur).subscribe({
        next: () => {
          this.notification('Importeur was updated', 'success');
          this.router.navigate(['/importeurs']);
        },
        error: () => this.notification('Error while updating Importeur', 'error')
      });
    } else {
      this.masterData.createImporteur(this.importeur).subscribe({
        next: (id: number) => {
          this.importeur!.importeurId = id;
          this.notification(`Importeur was created (ID: ${id})`, 'success');
          this.router.navigate(['/importeurs']);
        },
        error: () => this.notification('Error while creating Importeur', 'error')
      });
    }
  }

  cancelEdit() {
    this.importeur = null;
    this.router.navigate([`importeurs/`])
  }

  getAllCountrys() {
    this.masterData.GetAllCountrys().subscribe({
      next: (res) => {
        if (res) {
          this.availableCountrys = res;
          if (this.importeur) {
            if (this.importeur.country && this.importeur.country.countryId) {
              this.selectedCountryId = this.importeur.country.countryId;
            } else {
              this.importeur.country = this.availableCountrys[0];
              this.selectedCountryId = this.importeur.country.countryId;
            }
          }
        }
      },
      error: () => this.notification('Error while loading countries', 'error')
    });
  }

  private updateGridView() {
    this.gridView = process(this.contactPersons, this.gridState);
  }

  public dataStateChange(state: State): void {
    this.gridState = state;
    this.updateGridView();
  }

  public addHandler() {
    try {
      const newContactPerson: ContactPersonDTO = {
        databaseId: 0,
        firstName: 'First Name',
        lastName: 'Last Name',
        canBeDeleted: true,
      };
      this.contactPersons = [...this.contactPersons, newContactPerson];
      this.updateGridView()
      this.notification('New Contactperson was added', 'success');
    } catch {
      this.notification('Error while saving Contactperson', 'error');
    }
  }

  public editHandler() {
    this.editMode = !this.editMode
    this.currentContactPersons = this.contactPersons.map(cp => ({ ...cp }))
  }

  public openCancelDialog() {
    this.cancelDialog = true;
  }

  public cancelHandler() {
    try {
      this.contactPersons = this.originalContactPerson.map(cp => ({ ...cp }))
      this.toggleCancelDialog()
      this.updateGridView();
      this.notification('Changes were canceled', 'info');
      this.router.navigate(['/importeurs']);
    } catch {
      this.notification('Error while canceling the changes', 'error');
    }
  }

  public saveHandler() {
    this.editMode = !this.editMode
    this.updateGridView();
  }

  public removeHandler(item: ContactPersonDTO) {
    const index = this.contactPersons.indexOf(item);
    if (index > -1) {
      this.contactPersons.splice(index, 1);
      this.updateGridView();
      this.notification(`Contactperson "${item.firstName} ${item.lastName}" was removed`, 'warning');
    }
  }

  private loadImporteurDetail() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.masterData.getImporteurs(id).subscribe(importeurs => {
        this.importeur = importeurs[0];
        if (this.importeur) {
          this.importeur.importeurId = this.importeur.importeurId;
        }
        if (this.importeur && this.importeur.country) {
          this.selectedCountryId = this.importeur.country.countryId
          this.contactPersons = this.importeur.contactPersons.map(cp => ({ ...cp }));
          this.originalContactPerson = this.contactPersons.map(cp => ({ ...cp }));
          this.updateGridView();
        }
      });
    }
  }

  toggleCancelDialog() {
    this.cancelDialog = !this.cancelDialog
  }

  notification(message: string, state: any) {
    this.notificationService.show({
      content: message,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: state, icon: true }
    });
  }
}